// Close a UI element on outside click and/or Escape.
//
//   useDismissable(() => containerRef,                 onClose)
//   useDismissable(() => [inputRef, dropdownRef],      onClose, { event: 'click', escape: false })
//
// The getter is invoked at event time, so it's safe to pass a `let ref;` that
// only becomes non-null after mount. `null`/undefined entries are ignored.
import { onMount, onCleanup } from 'solid-js';

export function useDismissable(refsGetter, onClose, options = {}) {
  const eventName = options.event ?? 'mousedown';
  const escape    = options.escape !== false;

  const onDocEvent = (e) => {
    const raw = refsGetter();
    const list = (Array.isArray(raw) ? raw : [raw]).filter(Boolean);
    if (list.length === 0) return;                       // not mounted yet
    if (list.every((el) => !el.contains(e.target))) {
      onClose?.();
    }
  };

  const onKey = (e) => {
    if (e.key === 'Escape') onClose?.();
  };

  onMount(() => {
    document.addEventListener(eventName, onDocEvent);
    if (escape) document.addEventListener('keydown', onKey);
  });
  onCleanup(() => {
    document.removeEventListener(eventName, onDocEvent);
    if (escape) document.removeEventListener('keydown', onKey);
  });
}
